import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { delay } from 'rxjs/operators';
import { AppState } from '../../../../reducers';
import { ModalFullWidthMode } from '../../../../shared/_constants';
import { selectLoadingFlag } from '../../sections/company-drill-down/drill-down.selectors';

@Component({
  selector: 'app-drill-down-slide-out',
  templateUrl: './drill-down-slide-out.component.html',
  styleUrls: ['./drill-down-slide-out.component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class DrillDownSlideOutComponent implements OnInit {
  isFullScreen = false;
  loading$: Observable<boolean>;

  constructor(private activeModal: NgbActiveModal, private store: Store<AppState>) {}

  ngOnInit(): void {
    this.loading$ = this.store.pipe(select(selectLoadingFlag), delay(0));
  }

  close() {
    this.activeModal.close();
  }

  resize() {
    const modal = document.getElementsByClassName(this.isFullScreen ? ModalFullWidthMode.FULL_SCREEN_CSS_CLASS : ModalFullWidthMode.CSS_CLASS)[0];

    if (this.isFullScreen) {
      modal.classList.remove(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS);
      modal.classList.add(ModalFullWidthMode.CSS_CLASS);
      modal.classList.add(ModalFullWidthMode.FULL_SCREEN_EXIT_CSS_CLASS);
    } else {
      modal.classList.add(ModalFullWidthMode.FULL_SCREEN_CSS_CLASS);
      modal.classList.remove(ModalFullWidthMode.CSS_CLASS);
      modal.classList.remove(ModalFullWidthMode.FULL_SCREEN_EXIT_CSS_CLASS);
    }

    this.isFullScreen = !this.isFullScreen;
  }
}
